import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import MDBox from "../../../Components/MDBox";
import React, {forwardRef, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import {
    Autocomplete,
    Grid,
    Slide,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, TextField
} from "@mui/material";

import MDTypography from "../../../Components/MDTypography";
import Talar from "../../../Asset/images/talarg.png";
import {ReactComponent as Moshahede} from '../../../Asset/images/icons/lets-icons_view.svg'

import Fr1 from "../../../Asset/images/fr1.png";
import Fr2 from "../../../Asset/images/fr2.png";
import Fr3 from "../../../Asset/images/fr3.png";
import {MessageModel} from "../../../Api/Model/MessageModel";
import {ErrorToaast, InfoToaast} from "../../../utils/toast/Toast";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "../../../Components/MDButton";
import Paper from "@mui/material/Paper";
import {Table} from "reactstrap";
import MDTableCell from "../../../Components/MDTable/MDTableCell";
import MDTableRow from "../../../Components/MDTable/MDTableRow";
import {v4 as uuid} from "uuid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import MDInput from "../../../Components/MDInput";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const initalSearchParams = {
    Username: "",
    Role: "",
    AzSabt: "",
    TaSabt: "",
    Vaziat: ""
};
export default function StudentForum() {
    const [page, setPage] = useState(null)
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [searchParams, setSearchParams] = useState(initalSearchParams);
    const [sendmsgdialog, setSendmsgdialog] = useState({open: false, id: 0});
    const [msgdialog, setMsgdialog] = useState({open: false, msg: null});
    const [searchList, setSearchList] = useState([]);
    const [pplvalue, setPplValue] = React.useState();
    const [onvanmsg, setOnvanMsg] = React.useState("");
    const [textMsg, setTextMsg] = React.useState("");
    const [inputPplValue, setInputPplValue] = React.useState('');
    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    const [controller, dispatch] = useMaterialUIController();
        const navigate = useNavigate();
    const {loading} = controller;
    let Api = new MessageModel(Cookies.get("cst") ?? "");

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    const handleChange = (event, newValue) => {
        setCounter(p => p + 1);
    };

    function handleSearch(vaziat) {
        const {Username, Role, AzSabt, TaSabt, Vaziat} = searchParams;
        if (false) {
            return setCounter((c) => c + 1);
        } else {
            setLoading(dispatch, true);
            Api
                .GetSearch(
                    searchParams.Username,
                    searchParams.Role,
                    searchParams.AzSabt,
                    searchParams.TaSabt,
                    vaziat,
                )
                .then((r) => {
                    setRows({content: r.data.data, pageSize: 0, totalPages: 0});
                    setLoading(dispatch, false);
                })
                .catch((r) => {
                    setLoading(dispatch, false);
                    ErrorToaast("دریافت اطلاعات با مشکل مواجه شد");
                });
        }

    }

    const handleCloseMsg = () => {
        setOnvanMsg("")
        setTextMsg("")
        setPplValue("")
        setSendmsgdialog({id: 0, open: false})
    };

    function handleClickOpen(msg) {
        Api
            .ToggleRead(msg.id)
            .then((r) => {
                setMsgdialog({msg, open: true})
                setCounter(r => r + 1);
            })
            .catch(() => {
                ErrorToaast("خطا در دریافت اطلاعات")
            });
    }

    function handleCloseShowMsg() {
        setMsgdialog({msg: null, open: false})

    }

    function handleSection(number) {
        var s = new Promise((resolve, reject) => resolve());
        s.then(r => {
            setPage(number);
            console.log(1)
            
        }).then(() => {
            console.log(3)

            handleSearch(number )

        })

    }

    function sendNewMsg() {
        setSendmsgdialog({id: 0, open: true})
    }

    const handleSendMessage = () => {
        if (onvanmsg === "" || textMsg === "" || pplvalue === 0) {
            ErrorToaast("لطفا مقادیر را پر کنید")
            return;
        }
        Api
            .SendMessage({
                Text: textMsg,
                Title: onvanmsg,
                ReceiveId: pplvalue?.id
            })
            .then((r) => {
                setSendmsgdialog({id: 0, open: false})

                InfoToaast("پیام با موفقیت ارسال شد")
                setCounter(r => r + 1);
            })
            .finally(() => {
                setLoading(dispatch, false);
            });

    };

    useEffect(() => {
        setLoading(dispatch, true);

        Api.GetAllMsgPeople().then((r) => {
            setSearchList(r.data.data);
        }).catch
        (r => {
            if (r?.status == 404) {
                setLoading(dispatch, false)

                return
            }
            ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
            setLoading(dispatch, false)

        })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);
    return <HeroLayout>
        <MDBox mx={{xs: 2, md: 10, lg: 10}} mt={4}>
            <MDBox sx={{justifySelf: "center", cursor: "pointer"}} onClick={() => {
                setPage(null);
                setRows({content: [], pageSize: 0, totalPages: 0});
            }}>
                <img src={Talar} style={{height: "15vh"}}/>
            </MDBox>
        </MDBox>
        {page === null && <>
            <MDBox sx={{justifySelf: "center"}} pb={5}>
                <Grid container textAlign={"center"} gap={5} mt={5}>
                    <Grid item xs={12} sx={{cursor: "pointer"}}
                          onClick={() => handleSection(2)}>
                        <img src={Fr1} style={{height: "30vh"}}/>
                    </Grid>
                    <Grid item xs={12} sx={{cursor: "pointer"}}
                          onClick={() => handleSection(1)}>
                        <img src={Fr2} style={{height: "30vh"}}/>
                    </Grid>
                    <Grid item xs={12} sx={{cursor: "pointer"}}
                          onClick={() => sendNewMsg()}>
                        <img src={Fr3} style={{height: "30vh"}}/>
                    </Grid>
                    <Grid item xs={12} sx={{cursor: "pointer"}}
                          onClick={() => navigate("/studentlanding")}>
                        <MDTypography sx={{fontSize: "40px"}}>بازگشت</MDTypography>
                    </Grid>
                </Grid>
            </MDBox>
        </>}

        {[2, 1].includes(page) && <>
            <MDBox py={3}   p={2} mb={2} flex={1} borderRadius={2}>
                <Grid container flexDirection={"column"}>
                    <Grid item sx={{width: "100%"}}>
                        <TableContainer component={Paper} sx={{width: "100%"}}>
                            <Table sx={{minWidth: 700}} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام کاربری
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            وضعیت
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            مشاهده
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            تاریخ
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نقش
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            عنوان پیام
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            عملیات
                                        </MDTableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows?.content.length < 1 && (
                                        <MDTableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {border: 0},
                                            }}
                                        >
                                            <MDTableCell colSpan={9} align="right">
                                                بدون اطلاعات
                                            </MDTableCell>
                                        </MDTableRow>
                                    )}
                                    {rows?.content?.map((r) => {
                                        return (
                                            <MDTableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={uuid()}
                                            >
                                                <MDTableCell align={"center"}>
                                                    {r?.userUserName}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.vaziat}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.isRead ? "خوانده شده" : "خوانده نشده"}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {new Date(r?.created).toLocaleString('fa-IR')}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.role === "Student" && "دانش آموز"}
                                                    {r?.role === "Pezeshk" && "پزشک"}
                                                    {r?.role === "Morabi" && "مربی"}
                                                    {r?.role === "Parent" && "والدین"}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.title}
                                                </MDTableCell>


                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="مشاهده">
                                                        <IconButton onClick={() => handleClickOpen(r)}>
                                                            <Moshahede/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>

                                            </MDTableRow>


                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Grid>
                </Grid>

            </MDBox>
        </>}
        <Dialog
            open={sendmsgdialog.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseMsg}
            fullWidth
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>ارسال پیام</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>
                    <Grid container gap={5}>
                        <Grid item container gap={2}>
                            <MDTypography>
                                ارسال از طرف
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {CurrentUser()?.user.UserName}
                            </MDTypography>
                        </Grid>
                        <Grid item container gap={2} flex={1}>
                            <MDTypography>
                                نام کاربری گیرنده
                            </MDTypography>
                            {/*<div>*/}

                            <Autocomplete
                                value={pplvalue}
                                onChange={(event, newValue) => {
                                    setPplValue(newValue);
                                }}
                                inputValue={inputPplValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputPplValue(newInputValue);
                                }}
                                id="controllable-states-demo"
                                options={searchList}
                                fullWidth
                                renderInput={(params) => <TextField fullWidth sx={{width: "100%"}} {...params}  />}
                                // renderInput={(params) => <MDInput {...params} label="Controllable"/>}
                            />
                            {/*</div>*/}

                        </Grid>
                        <Grid container item>
                            <MDInput
                                id="onvanmsg"
                                name="onvanmsg"
                                value={onvanmsg}
                                onChange={(r) => setOnvanMsg(r.target.value)}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%"}}
                                fullWidth
                                label={"عنوان گفتگو"}/>

                        </Grid>
                        <Grid container item>
                            <MDInput
                                id="textMsg"
                                name="textMsg"
                                multiline
                                rows={4}
                                value={textMsg}
                                onChange={(r) => setTextMsg(r.target.value)}
                                // error={
                                //     Boolean(formik.errors.Varzesh)
                                // }
                                // helperText={formik.errors.Varzesh}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%"}}
                                fullWidth
                                label={"متن     "}/>

                        </Grid>
                    </Grid>

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={"outlined"} color={"warning"} size={"large"}
                          onClick={handleSendMessage}>ارسال</MDButton>
                <MDButton variant={"outlined"} color={"info"} size={"large"} onClick={handleCloseMsg}>بازگشت</MDButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={msgdialog.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseShowMsg}
            fullWidth
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>مشاهده پیام</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>
                    <Grid container gap={1}>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}>

                            <MDTypography>
                                ارسال از طرف
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.userUserName}
                            </MDTypography>

                        </Grid>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}>
                            <MDTypography>
                                عنوان
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.title}
                            </MDTypography>
                        </Grid>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}
                              minHeight={"200px"}>
                            <MDTypography>
                                متن
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.text}
                            </MDTypography>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={"outlined"} color={"info"} size={"large"}
                          onClick={handleCloseShowMsg}>بازگشت</MDButton>
            </DialogActions>
        </Dialog>
    </HeroLayout>
}